// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1mrOl","consentsList":"PatientConsents_consentsList__1fTur","consentsListEmpty":"PatientConsents_consentsListEmpty__3r5Nx"};